import $ from 'jquery';
import analytics from '../../services/analytics_service';
import config from '../../config';

export default () => {
    if (config.get('featureFlags.piwikEnabled') === true) {
        const $document = $(document);
        const setUpClickEvents = (conf) => {
            const { selector, name } = conf;
            $document.on('click', selector, function () {
                // console.log(name);
                analytics.trackClick(name, document.location.href);
            });
        };
        [
            {
                selector: '.js-author',
                name: 'author'
            },
            {
                selector: '.top-stories-afterbody',
                name: 'top_stories_afterbody'
            },
            {
                selector: '.the-latest-list',
                name: 'the_latest'
            },
            {
                selector: '.js-up-next',
                name: 'up_next'
            }
        ].forEach(setUpClickEvents);
    }
};
